import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyMyOffers = lazy(() => import('./MyOffers'));

export const MyOffers: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyMyOffers {...props} />
	</Suspense>
);
